import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Async thunk for fetching website settings
export const fetchWebsiteSettings = createAsyncThunk(
  'statistics/fetchWebsiteSettings',
  async (websiteType = 4, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/Common/GetWebsiteSettings',
        { websiteType },
        { headers: { 'Content-Type': 'application/json-patch+json' } }
      );
      return JSON.parse(response.data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState: {
    settings: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebsiteSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWebsiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchWebsiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default statisticsSlice.reducer;
